import styled from 'styles/styled';

export const Wrap = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabStrip = styled.div`
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #2A2E34;
  margin-bottom: 8px;
`;

export const TabBtn = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #7A7E8C;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: color 200ms, border-color 200ms;

  &:hover {
    color: #EFEFEF;
  }

  &.active {
    color: #EFEFEF;
    border-color: #52D381;
    font-weight: 700;
  }
`;

export const ScrollWrap = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  max-height: 320px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #2A2E34;
    border-radius: 4px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
`;

export const Th = styled.th`
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7A7E8C;
  font-weight: 600;
  text-align: left;
  padding: 8px 10px;
  background: #15191E;
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;

  &.right {
    text-align: right;
  }

  &.center {
    text-align: center;
  }
`;

export const Td = styled.td`
  font-size: 12px;
  color: #EFEFEF;
  padding: 8px 10px;
  border-top: 1px solid #2A2E34;
  white-space: nowrap;

  &.muted {
    color: #A7A8B2;
  }

  &.right {
    text-align: right;
  }

  &.center {
    text-align: center;
  }

  &.up_state {
    color: #52D381;
  }

  &.down_state {
    color: #FF6782;
  }

  &.detail_state {
    color: #A7A8B2;
  }
`;

export const Tr = styled.tr`
  transition: background 120ms;

  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }

  &.confirming {
    background: rgba(255, 103, 130, 0.05);
  }
`;

export const PairCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PairIcon = styled.span<{ $src?: string }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-image: ${(p) => (p.$src ? `url(${p.$src})` : 'none')};
  background-size: cover;
  background-position: center;
  background-color: #292B2E;
  flex-shrink: 0;
`;

export const SideLevCell = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const SideBadge = styled.span<{ $side?: 'long' | 'short' }>`
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${(p) => (p.$side === 'short' ? '#FF6782' : '#52D381')};
  background: ${(p) =>
    p.$side === 'short' ? 'rgba(255, 103, 130, 0.12)' : 'rgba(82, 211, 129, 0.12)'};
`;

export const LevBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #EFEFEF;
  background: #292B2E;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const PnlCell = styled.div<{ $pos?: boolean; $neg?: boolean }>`
  color: ${(p) => (p.$pos ? '#52D381' : p.$neg ? '#FF6782' : '#EFEFEF')};
  font-weight: 700;
  font-variant-numeric: tabular-nums;

  small {
    display: block;
    font-size: 10px;
    font-weight: 500;
    opacity: 0.85;
  }
`;

export const TPSLBox = styled.button`
  background: #292B2E;
  border: 0;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
  font-family: inherit;
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;

  &:hover {
    background: #1B1F25;
  }

  .row {
    display: inline-flex;
    gap: 6px;
    font-size: 10px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;

    .l {
      letter-spacing: 0.04em;
    }

    .tp {
      color: #52D381;
    }

    .sl {
      color: #FF6782;
    }

    .v {
      color: #EFEFEF;
    }

    .empty {
      color: #7A7E8C;
    }
  }
`;

export const ActionBtn = styled.button<{ $tone?: 'danger' | 'neutral' | 'confirm' }>`
  background: ${(p) =>
    p.$tone === 'confirm' ? '#52D381' : p.$tone === 'danger' ? '#FF6782' : '#292B2E'};
  border: 0;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 11px;
  font-weight: 700;
  color: ${(p) => (p.$tone === 'confirm' || p.$tone === 'danger' ? '#0A0A0A' : '#EFEFEF')};
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: opacity 120ms, background 120ms;

  &:hover:not(:disabled) {
    opacity: 0.92;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmCluster = styled.div`
  display: inline-flex;
  gap: 6px;
  align-items: center;
`;

export const ConfirmText = styled.span`
  font-size: 11px;
  color: #FF6782;
  font-weight: 600;
  margin-right: 4px;
`;

export const StatusBadge = styled.span<{ $kind?: 'filled' | 'canceled' | 'pending' }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${(p) =>
    p.$kind === 'filled'
      ? '#52D381'
      : p.$kind === 'canceled'
      ? '#7A7E8C'
      : '#F2A900'};
  background: ${(p) =>
    p.$kind === 'filled'
      ? 'rgba(82, 211, 129, 0.12)'
      : p.$kind === 'canceled'
      ? 'rgba(122, 126, 140, 0.12)'
      : 'rgba(242, 169, 0, 0.12)'};
`;

export const Empty = styled.div`
  font-size: 12px;
  color: #7A7E8C;
  text-align: center;
  padding: 24px;
`;

export const WrapTPSL = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const WrapModal = styled.div`
  background: #15191E;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 360px;
  position: relative;

  h4 {
    font-size: 14px;
    color: #EFEFEF;
    font-weight: 700;
    margin: 0 0 16px;
  }
`;

export const ClosePopup = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7A7E8C;

  &::before {
    content: '×';
    font-size: 24px;
    line-height: 1;
  }

  &:hover {
    color: #EFEFEF;
  }
`;
